/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}.locked-overlay[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;height:100%;background-color:rgba(103,178,231,.8);color:#fff;font-weight:700}.locked-overlay[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:3rem;width:3rem}.locked-overlay[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;padding:.5rem}@media (max-width:525px),(min-width:525px) and (max-width:991px){.locked-overlay[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:.8125rem;margin-bottom:.5rem}}"];
export { styles as styles };
//# sourceMappingURL=card-locked-overlay.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/card-locked-overlay/card-locked-overlay.component.scss.shim.ngstyle.js
// module id = 1558
// module chunks = 27 28 29